/* This is updated by the Jenkins script to reflect
   the value of the sha commit
   @see JenkinsFile
 */
export const commit_sha : string = 'PHEWEB VERSION : 4de11757ae95850bbee0d49ad6a0ee15a322896b';
